import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { map, times } from 'lodash';
import { useTranslation } from 'react-i18next';

const EligibilitySection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-5">
      <Container>
        <h2 className="text-center">{t('healthInsurancePage.eligibilitySection.title')}</h2>
        <p className="text-center text-secondary w-75 mx-auto">
          {t('healthInsurancePage.eligibilitySection.subTitle')}
        </p>
        <Row className="gy-4 mt-5">
          {map(times(3), (idx) => (
            <Col md={6} lg={4} key={`eligibilityItem${idx + 1}`}>
              <Card className="shadow bg-body border-0 h-100">
                <Card.Body>
                  <Card.Title className="my-4 text-center">
                    <h4 className="fw-bold">{t(`healthInsurancePage.eligibilitySection.item${idx + 1}.label`)}</h4>
                  </Card.Title>
                  <Card.Text>{t(`healthInsurancePage.eligibilitySection.item${idx + 1}.desc`)}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export { EligibilitySection };
